import { useEffect, useState } from 'react'
import Header from '../../../components/Header'
import Table from '../CartComponent/Table';
import Address from '../CartComponent/Address/Address';
import CouponSection from '../CartComponent/Coupon/CouponSection';
import Couponsummary from '../CartComponent/Coupon/Couponsummary';

const Coupon = ({ cartInfo, address, shippingCharges, popup, onAddressChange }) => {
  const [showbtn, setshowbtn] = useState(false);
  const [taxable_total, settaxable_total] = useState(0);
  const [tableData, settableData] = useState([]);
  const [total_coupon_Amount, settotal_coupon_Amount] = useState(0);
  const [client_Discount_Status, setclient_Discount_Status] = useState(false)
  const [outofstock, setOutOfStock] = useState(false);
  const [couponlist, setcouponlist] = useState([]);
  const [gst_total, setgst_total] = useState(0);
  const [totalmrp, settotalmrp] = useState(0);
  const [totalqty, settotalqty] = useState(0);

  useEffect(() => {
    const product_list = cartInfo.cartData.product_deatils;
    settableData(product_list);
    setclient_Discount_Status(product_list.some(item => item.cli_discount > 0));  // client Discount 
    setOutOfStock(product_list.some((item) => item.stock == 0));  // any Item is Out of Stock
    settotalqty(product_list.reduce((acc, product) => acc + 1 * product.quantity, 0));  // Total Item QTY
    settotalmrp(product_list.reduce((acc, product) => acc + product.price_excl_tax * product.quantity, 0));  // total MRP Price
    setgst_total(product_list.reduce((total, item) => total + item.gst_tax_amount * item.quantity, 0));  // total GST
    settaxable_total(product_list.reduce((total, item) => total + item.base_price * item.quantity, 0));  // total Taxable Amount
    setcouponlist(cartInfo.cartData.voucher_list);  // Coupon List
    settotal_coupon_Amount(cartInfo.cartData.voucher_list.reduce((acc, voucher) => acc + voucher.offer, 0)); // Total Amount of Vouchers
  }, [cartInfo])

  return (
    <>
      <Header />

      <div className='breadcrumb-main margincart'></div>
      <section className="section-big-py-space b-g-light">
        <div className="container-fluid d-flex justify-content-center">
          <div className="row justify-content-center definewidth align-items-start">
            <div className="col-lg-8" style={{ paddingBottom: "4px" }}>

              <Table
                cartInfo={cartInfo}
                tableData={tableData}
                status={{ client_Discount_Status, setshowbtn }}
                count={{ taxable_total, gst_total, totalmrp, totalqty }}
              />

              {totalqty > 0 ? (
                <CouponSection
                  couponInfo={{ couponlist, total_coupon_Amount }}
                  cartInfo={cartInfo}
                  setshowbtn={setshowbtn}
                />)
                : ''}
            </div>

            <div className=" col-lg-4 mt-lg-0 mt-md-0 mt-sm-3 mt-xs-3 makestk">
              <Address address={address} onAddressChange={onAddressChange} />
          
              <Couponsummary
                cartInfo={cartInfo}
                address={address}
                couponlist={couponlist}
                shippingCharges={shippingCharges}
                status={{ client_Discount_Status, setshowbtn, showbtn,outofstock,isTableEmpty:tableData.length }}
                count={{ taxable_total, gst_total, totalmrp, totalqty, total_coupon_Amount }}
              />

            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Coupon